import { render } from "./ArgonProgress.vue?vue&type=template&id=4dae5ef0"
import script from "./ArgonProgress.vue?vue&type=script&lang=js"
export * from "./ArgonProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__